import axios from 'axios';
import Cookies from 'js-cookie';

const { NODE_ENV } = process.env;
// global headers
const refid = Cookies.get('refid');
if (refid) axios.defaults.headers.refid = refid;

const baseURL = NODE_ENV === 'development' 
  ? 'https://localhost:5000/api/' 
  : 'https://ec.rockgp.com:5001/api/';

const instance = axios.create({ baseURL });

export default instance;

export function generateAuthHeaders() {
  const token = Cookies.get('accessToken');
  return { Authorization: token };
}

export function generateAuthPostConf(url, data = {}) {
  return {
    headers: generateAuthHeaders(),
    method: 'post',
    url,
    data
  };
}

export const actionEnhancer = loadingMutation => fn => (context, payload) => {
  context.commit(loadingMutation, true);
  return fn(context, payload)
    .then((res) => {
      context.commit(loadingMutation, false);
      return res;
    })
    .catch((err) => {
      context.commit(loadingMutation, false);
      console.log(err);
    });
};

export const log = (payload) => {
  const config = generateAuthPostConf('Users/SaveLog', payload);
  return instance(config);
};

export const EventLog = (payload) => {
  const config = generateAuthPostConf('Users/EventLog', { ...payload, refId: refid  });
  return instance(config);
}

export const PetFoodInfo = (payload) => {  
  const config = generateAuthPostConf('Users/PetFoodInfo', { ...payload, refId: refid  });
  return instance(config);
}

// 重新封裝 ipify，因為 global headers 緣故
export const getIp = () => new Promise((res) => {
  const xhr = new XMLHttpRequest();
  xhr.onreadystatechange = () => {
    if (xhr.readyState === 4 && xhr.status === 200) {
      const { ip } = JSON.parse(xhr.responseText);
      res(ip);
    }
    if (xhr.readyState === 4 && xhr.status !== 200) res('');
  };
  xhr.open('GET', 'https://api.ipify.org/?format=json', true);
  xhr.send(null);
});